import { ComponentManager, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";

export default class WorkflowExecutionLinkContainerDTO extends DataTransferObject {
    public Links: any;

    constructor() {
        super({xmlProperties: ['Links'], xmlNamespace: 'WorkflowEngine'});
        this.Links = this.defaultFromType('array');
    }
}

ComponentManager.setModel('WorkflowExecutionLinkContainerDTO', WorkflowExecutionLinkContainerDTO, 'WorkflowEngineHTMLViewExtension');